import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { CommonFormService } from 'src/app/shared/utils/common-form.service';
import {
  LfsaBotonEditarGridComponent
} from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { comisionesModulo } from '../../diccionarios/comisionesModulo';
import { AsignacionCalendariosService } from '../../services/asignacion-de-calendarios.service';
import { TipoDeVendedorService } from '../../services/tipo-de-vendedor.service';
import { IndicadoresVivosService } from 'src/app/aplicaciones-modulos/indicadores-vivos/services/indicadores-vivos.service';
import { CalendarioService } from '../../services/calendario.service';



@Component({
  selector: 'app-asignacion-de-calendarios',
  templateUrl: './asignacion-de-calendarios.component.html',
  styleUrls: ['./asignacion-de-calendarios.component.css']
})
export class AsignacionCalendarioComponent implements OnInit {

  tituloCard: string = 'Asignación de Calendarios';
  tituloForm: string = 'Lista De Asignación de Calendarios';

  formulario: FormGroup;

  mostrarFormulario: boolean = false;
  editableForm: boolean = false;

  rowData: any[] = [];
  frameworkComponents: any;
  gridApi: any;
  gridColumnApi: any;
  columnDefs: any[];
  rowSelection: any;
  textoBuscar: string;

  //componentes para apuntar a diccionario
  DAT_BTNS;
  DAT_MSG;
  DAT_BTNCSS;

  textBoton: string;

  //para cargar con el grid
  listaVacia: boolean = true;
  loading: boolean = false;
  modulo: any = {};
  GUARDAR: string = 'guardar';

  cmbEstados: any[] = [
    {
      clave: 'ACTIVO',
      valor: 'ACTIVO'
    },
    {
      clave: 'INACTIVO',
      valor: 'INACTIVO'
    },
  ];

  cmbSiNo: any[] = [
    {
      clave: '1',
      valor: 'SI'
    },
    {
      clave: '0',
      valor: 'NO'
    },
  ];

  constructor(
    private fb: FormBuilder,
    private commonFormService: CommonFormService,
    private _utils: UtilsService,
    private _serviciosCRUD: AsignacionCalendariosService,
    private _tiposDeVendedores: TipoDeVendedorService,
    private _indicadores: IndicadoresVivosService,
    private _calendario: CalendarioService,
  ) { }

  ngOnInit() {
    this.modulo = comisionesModulo;
    this.DAT_BTNS = this.modulo.button.buttonsNombre;
    this.DAT_MSG = this.modulo.mensajes;
    this.DAT_BTNCSS = this.modulo.button.buttonsCss;

    this.formulario = this.fb.group({
      idCalendario: ['', [Validators.required]],
      periodo: ['', []],
      totalMes: ['', []],
      totalDias: ['', []],
      predeterminado: ['', []],
      idVendedorTipo: ['', [Validators.required]],
      vendedorTipo: ['', []],
    });

    this.cargarGridcomponent();
    this.getTodo();
    this.tiposDeVendedores();
    this.getCalendarios();

  }

  /* FUNCIONES */

  listTiposDeVendedores;
  tiposDeVendedores() {
    this.loading = true;
    this._tiposDeVendedores.getTiposDeVendedores().subscribe((res: any[]) => {
      console.log("tiposDeVendedores()", res)
      this.loading = false;
      this.listTiposDeVendedores = res;
    }, (err) => {
      this.loading = false;
      this.listTiposDeVendedores = [];
    });
  }

  listCalendarios;
  getCalendarios() {
    this.loading = true
    this._calendario.getCalendarios().subscribe((res: any[]) => {
      console.log("getCalendarios()", res)
      this.loading = false;
      this.listCalendarios = res.filter(calendario => calendario.predeterminado == "NO");

      for (let i = 0; i < this.listCalendarios.length; i++) {
        this.listCalendarios[i].label = "ID: " + this.listCalendarios[i].idCalendario + " Año: " + this.listCalendarios[i].periodo + " Dias: " + this.listCalendarios[i].totalDias + " Meses: " + this.listCalendarios[i].totalMes;
      }
      
    }, (err) => {
      this.loading = false;
      this.listCalendarios = [];
    });
  }

  cargarGridcomponent() {
    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };
    this.columnDefs = [
      {
        headerName: 'Id',
        field: 'idCalendario',
        filter: true,
        sortable: true,
        // width: 120,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Periodo',
        field: 'periodo',
        sortable: true,
        // width: 160,
        filter: true,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Meses Configurados',
        field: 'totalMes',
        sortable: true,
        // width: 160,
        filter: true,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Total, Días Calendario',
        field: 'totalDias',
        sortable: true,
        // width: 160,
        filter: true,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Calendario Asignado a Tipo de Vendedor',
        field: 'vendedorTipo',
        sortable: true,
        // width: 160,
        filter: true,
        // cellStyle: this.changeCellColor.bind(this),
      },
      // {
      //   headerName: '',
      //   cellRenderer: 'buttonRenderer',
      //   width: 150,
      //   cellRendererParams: {
      //     onClick: this.editar.bind(this),
      //     label: this.DAT_BTNS.editar,
      //     colorBoton: this.DAT_BTNCSS.warning
      //   }
      // },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 150,
        cellRendererParams: {
          onClick: this.eliminar.bind(this),
          label: this.DAT_BTNS.eliminar,
          colorBoton: this.DAT_BTNCSS.danger
        }
      },
    ];

    this.rowSelection = 'multiple';
  }

  onQuickFilterChanged() {
    this.gridApi.setQuickFilter(this.textoBuscar);
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;

    params.api.sizeColumnsToFit();

  }

  nuevo() {
    this.formulario.reset();
    this.commonFormService.abrirFormularioParaGuardar(this);
    this.textBoton = this.DAT_BTNS.guardar;
    this.tituloForm = 'Guardar Asignación de Calendario';
  }

  editar({ rowData }) {
    console.log("editar", rowData)
    this.formulario.reset();
    this.formulario.setValue(rowData);
    document.getElementById('buttonAbrirModal').click();
  }

  acciones(event) {
    // debugger
    if (event === this.GUARDAR) {
      this.guardar();
    } else {
      this.limpiarRegresar();
    }
  }

  limpiarRegresar() {
    this.mostrarFormulario = false;
    this.tituloCard = 'Mantenedor Asignación de Calendarios';
    this.tituloForm = 'Lista De Asignación de Calendarios';
  }

  /** SERVICIOS */
  getTodo() {
    this.listaVacia = true;
    this.loading = true;

    this._serviciosCRUD.getTodo().subscribe((res: any[]) => {
      console.log("getTodo()", res)
      this.loading = false;
      this.listaVacia = (res.length === 0) ? true : false;
      this.rowData = res;
    }, (err) => {
      this.loading = false;
      this.listaVacia = true;
      this.rowData = [];
    });
  }

  eliminar({ rowData }) {
    console.log("eliminar", rowData)
    let datos = rowData;

    datos.calendarioId = datos.idCalendario;
    datos.tipoVendedorId = datos.idVendedorTipo;

    this._utils
      .confirmarSincronoPromesa({
        title: this.DAT_MSG.eliminar,
        // text: `${rowData.idValorFlete}`,
        action: this.DAT_BTNS.eliminar,
        funcion: this._serviciosCRUD.delete(datos),
      })
      .then((res: any) => {
        this.getTodo();
        this.loading = false;
      })
      .catch(() => {
        this.loading = false;
      });

  }

  guardar() {

    let datos = this.formulario.getRawValue();
    datos.calendarioId = datos.idCalendario;
    datos.tipoVendedorId = datos.idVendedorTipo;

    this._utils.confirmarSincronoPromesa(
      {
        title: this.DAT_MSG.guardar,
        text: '',
        action: this.DAT_BTNS.guardar,
        funcion: this._serviciosCRUD.save(datos),
        loading: true,
        context: this,
      }
    ).then((res: any) => {
      this.limpiarRegresar();
      this.formulario.reset();
      this.getTodo();
    }).catch((err) => {
      console.log(err);
      // this._utils.mensajeErroToast(err.error.message, 5000);
    });
  }

  actualizar() {
    console.log("actualizar")

    console.log(this.formulario.getRawValue())
    this._utils.confirmarSincronoPromesa(
      {
        title: this.DAT_MSG.actualizar,
        text: '',
        action: this.DAT_BTNS.actualizar,
        funcion: this._serviciosCRUD.update(this.formulario.getRawValue()),
        loading: true,
        context: this,
      }
    ).then((res: any) => {
      this.formulario.reset();
      this.getTodo();
      document.getElementById('cerrarModal').click();
    }).catch((err) => {
      console.log(err);
      // this._utils.mensajeErroToast(err.error.message, 5000);
    });
  }

  getFormValidationErrors() {

    console.log('%c ==>> Validation Errors: ', 'color: red; font-weight: bold; font-size:25px;');

    let totalErrors = 0;

    Object.keys(this.formulario.controls).forEach(key => {
      const controlErrors: ValidationErrors = this.formulario.get(key).errors;
      if (controlErrors != null) {
        totalErrors++;
        Object.keys(controlErrors).forEach(keyError => {
          console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
        });
      }
    });

    console.log('Number of errors: ', totalErrors);
  }

  getVendedor(event) {
    if (event.key == " " || event.code == "Space" || event.keyCode == 32) return;
    this.loading = true;
    if (this.formulario.get("cedula").value != null && this.formulario.get("cedula").value.length > 0) {
      this._serviciosCRUD.getVendedorPorCedula(this.formulario.get("cedula").value).subscribe(
        (resp) => {
          if (resp) {
            this.formulario.controls['nombreVendedor1'].setValue(resp[0].nombres);
            this.formulario.controls['codigoSap'].setValue(resp[0].codigoSap);
            this.formulario.controls['cargoNominal'].setValue(resp[0].dscaCargo);
          } else {
            this.formulario.controls['nombreVendedor1'].setValue('');
            this.formulario.controls['codigoSap'].setValue('');
            this.formulario.controls['cargoNominal'].setValue('');
          }
          this.loading = false;
        },
        (error) => {
          this.loading = false;
          this.formulario.controls['nombreVendedor1'].setValue('');
          this.formulario.controls['codigoSap'].setValue('');
          this.formulario.controls['cargoNominal'].setValue('');
        }
      );
    }
  }

  getVendedor2() {
    this.loading = true;
    if (this.formulario.get("cedula").value != null && this.formulario.get("cedula").value.length > 0) {
      this._serviciosCRUD.getVendedorPorCedula(this.formulario.get("cedula").value).subscribe(
        (resp) => {
          if (resp) {
            this.formulario.controls['nombreVendedor1'].setValue(resp[0].nombres);
            this.formulario.controls['codigoSap'].setValue(resp[0].codigoSap);
            this.formulario.controls['cargoNominal'].setValue(resp[0].dscaCargo);
          } else {
            this.formulario.controls['nombreVendedor1'].setValue('');
            this.formulario.controls['codigoSap'].setValue('');
            this.formulario.controls['cargoNominal'].setValue('');
          }
          this.loading = false;
        },
        (error) => {
          this.loading = false;
          this.formulario.controls['nombreVendedor1'].setValue('');
          this.formulario.controls['codigoSap'].setValue('');
          this.formulario.controls['cargoNominal'].setValue('');
        }
      );
    }
  }

}
